export const GET_VIDEO_TASK_COMPLETION_STATUS = 'GET_VIDEO_TASK_COMPLETION_STATUS';
export const VIDEO_TASK_COMPLETION_STATUS_RESPONSE = 'VIDEO_TASK_COMPLETION_STATUS_RESPONSE';
